export default {
  TANGEM_CHECKOUT_URL:
    import.meta.env.PUBLIC_TANGEM_CHECKOUT_URL || "https://store.tangem.com",
  TANGEM_BACKEND_URL:
    import.meta.env.PUBLIC_TANGEM_BACKEND_URL || "https://store-api.tangem.com",
}